module.exports = __webpack_public_path__ + "img/1.b6b9fd1a.png";